<template>
    <q-modal v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" @hide="hideModal()">
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense v-close-overlay icon="close" />
                <q-toolbar-title>{{ $t('add_new_topic').toUpperCase() }}</q-toolbar-title>
            </q-toolbar>

            <div class="row q-ma-md">
                <div class="col-12">
                    <q-field :count="256">
                        <q-input class="q-my-sm" v-model="topic" max-length="256" :float-label="$t('topic')" :error="$v.topic.$error" @input="$v.topic.$touch" />
                    </q-field>
                    <span class="q-my-xs copy">{{ $t('subject') }}</span>
                    <editor class="q-my-sm" :initialText="initial_text" :editorText="message" :imagePath="image_path" :custom_directory="custom_directory" :imageUpload="image_upload" @setMessage="setMessage" @setMessageWithImage="setMessageWithImage" :id="new_uid" />
                </div>
            </div>

            <q-toolbar slot="footer">
                <q-btn class="q-mx-sm" color="positive" :label="$t('add')" :disabled="topic.length < 4 || message.length < 4" @click="addTopic" />
                <q-btn class="q-mx-sm" color="negative" :label="$t('cancel')" @click="hideModal()" />
            </q-toolbar>

        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { uid } from 'quasar'

export default {
    props: ['show'],

    data() {
        return {
            topic: '',
            initial_text: '',
            message: '',
            image_upload: true,
            image_path: 'media/html_images/courses/forum',
            custom_directory: false,
            new_uid: 1,
        }
    },

    components: {
        'editor': () => import('components/editor/Editor'),
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_modal: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('hideModal', '')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '70vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '80vw'
        },
    },

    methods: {
        hideModal() {
            this.$emit('hideModal', '')
        },

        setMessage(val) {
            this.message = val
        },

        setMessageWithImage(val) {
            this.message = val
            this.initial_text = val
            this.new_uid = uid()
        },

        addTopic() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let topicData = {"title": this.topic, "question": this.message}

                this.$axios.post(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/create_topic/`, topicData, this.getHeader)
                .then(response => {
                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('add_topic_success'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })
                    this.hideModal()

                })
                .catch(e => {
                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('add_topic_error'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
                    this.hideModal()

                    console.log(e)
                })
                .finally(() => {
                    this.new_uid = uid()
                    this.initial_text = ''
                    this.message = ''
                    this.topic = ''
                })
            }
        }
    },

    validations() {
        return {
            topic: { required },
            message: { required },
        }
    },

    mounted () {
        this.new_uid = uid()
    },

}
</script>

<style lang="stylus" scoped>
.copy {
    color #0072ce;
    font-weight 400
}

</style>
